module.exports = __webpack_public_path__ + "static/img/b6_body.eeab027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b6_body.png
// module id = 6yUG
// module chunks = 1